import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { AutoComplete, Button, Icon, Input, Spin, Tooltip, Select } from "antd";
// import { SearchOutlined, Loading } from '@ant-design/icons';
import axios from 'util/Api'
// import { Link } from "react-router-dom";
// import QrScan from '../QrReader/QRScan';

const { Option } = AutoComplete;

const AssetSearch = ({
    styleName,
    width = '100%',
    placeholder,
    onChange,
    assetData,
    onSelect,
    loading,
    defaultAsset,
    disabled = false,
    multiple = false,
    isOnlyIOTAsset = false,
    // authUser
}) => {
    const [selectedAssets, setSelectedAssets] = useState(defaultAsset ? [defaultAsset._id] : [])
    const [searchText, setSearchText] = useState('')
    const [singleValue, setSingleValue] = useState(defaultAsset ? defaultAsset._id : undefined)
    const [soldLocation, setSoldLocation] = useState({ _id: '', name: '' })

    // Debug logging
    // console.log('AssetSearch render:', {
    //     defaultAsset: defaultAsset && defaultAsset._id,
    //     singleValue,
    //     selectedAssets,
    //     multiple
    // })
    // console.log('assetData =>', assetData)
    // console.log('authUser =>', authUser)

    useEffect(() => {
        axios.get(`/location/get-by-name/sold`)
            .then(res => {
                // console.log('res =>', res)
                setSoldLocation(res.data)
            })
            .catch(err => {
                console.log('err =>', err)
            })
    }, [])

    // Ensure state is synchronized with defaultAsset prop
    useEffect(() => {
        if (defaultAsset && !singleValue) {
            setSingleValue(defaultAsset._id)
            if (multiple) {
                setSelectedAssets([defaultAsset._id])
            }
        }
    }, [defaultAsset, multiple])

    const handleSearch = (value) => {
        setSearchText(value)
        if (onChange && value.length > 2) {
            onChange(value)
        }
    }

    const handleSelect = (values) => {
        if (multiple) {
            // values is already an array of selected values
            setSelectedAssets(values)
            onSelect(values)
            // Clear search text after selection
            setSearchText('')
        } else {
            // For single selection, values will be a single value
            onSelect(values)
            setSingleValue(values)
            setSearchText('')
        }
    }

    const handleDeselect = (removedValue) => {
        if (multiple) {
            const newSelectedAssets = selectedAssets.filter(id => id !== removedValue)
            setSelectedAssets(newSelectedAssets)
            onSelect(newSelectedAssets)
        }
    }

    const renderOption = (item) => {
        const title = `${item.assetCode || ''} / ${item.altName || ''} / ${item.ownerCode || ''}`
        return {
            value: item._id,
            key: item._id,
            text: title,
            label: (
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>{title}</span>
                    {item.assetModel && <span style={{ color: '#888' }}>{item.assetModel.name}</span>}
                </div>
            )
        }
    }

    // console.log('defaultAsset =>', defaultAsset)
    // console.log('assetData =>', assetData)
    // console.log('singleValue =>', singleValue)
    // console.log('selectedAssets =>', selectedAssets)
    // console.log('Select value will be:', multiple ? selectedAssets : singleValue)
    // console.log('soldLocation =>', soldLocation)
    return (
        <Select
            key={defaultAsset ? defaultAsset._id : 'no-default'}
            disabled={disabled}
            mode={multiple ? 'multiple' : undefined}
            showSearch
            value={multiple ? selectedAssets : singleValue}
            placeholder={placeholder}
            style={{ width }}
            defaultActiveFirstOption={false}
            showArrow={true}
            filterOption={false}
            onSearch={handleSearch}
            onChange={handleSelect}
            onDeselect={handleDeselect}
            notFoundContent={loading ? <Spin size="small" /> : null}
            className={`global-search ${styleName}`}
            clearIcon={<Icon type="close" />}
        >
            {defaultAsset && (
                <Select.Option key={defaultAsset._id} value={defaultAsset._id}>
                    {`${defaultAsset.assetCode || ''} / ${defaultAsset.altName || ''} / ${defaultAsset.ownerCode || ''}`}
                </Select.Option>
            )}
            {assetData && assetData.filter(item => item.location && item.location !== soldLocation._id).map(item => (
                <Select.Option key={item._id} value={item._id}>
                    {`${item.assetCode || ''} / ${item.altName || ''} / ${item.ownerCode || ''}`}
                </Select.Option>
            ))}
        </Select>
    )
}

AssetSearch.propTypes = {
    styleName: PropTypes.string,
    width: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    assetData: PropTypes.array,
    onSelect: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    defaultAsset: PropTypes.object,
    multiple: PropTypes.bool,
    authUser: PropTypes.object
}

// const mapStateToProps = ({ auth }) => {
//     return {
//         authUser: auth.authUser,
//     }
// }

export default AssetSearch
